import React from "react";
import "./painelCaloriasDia.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFireFlameCurved,
  faDrumstickBite,
  faBreadSlice,
  faCheese,
  faCircleInfo,
  faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";

const PainelCaloriasDia = ({
  calorias,
  metaCalorias,
  onAbrirModalRefeicao,
  mostrarBotaoRefeicao,
  permiteEditarRefeicao,
  progressoCalorias,
  macrosDia,
  possuiMacros,
  refeicoesDia,
  obterNomeRefeicao,
  obterIconeRefeicao,
  onCliqueRefeicao,
  onCliqueExcluir,
}) => {
  const handleCliqueLinha = (refeicao) => {
    if (onCliqueRefeicao) {
      onCliqueRefeicao(refeicao);
    }
  };

  const handleCliqueInfo = (e, refeicao) => {
    e.stopPropagation();
    if (onCliqueRefeicao) {
      onCliqueRefeicao(refeicao);
    }
  };

  const handleCliqueExcluir = (e, refeicao) => {
    e.stopPropagation();
    if (onCliqueExcluir) {
      onCliqueExcluir(refeicao);
    }
  };

  return (
    <div className="painel-bloco">

      <div className="painel-calorias-header">
        <h3>
          <FontAwesomeIcon
            icon={faFireFlameCurved}
            className="icone-calorias"
          />{" "}
          Calorias do Dia
        </h3>

        {/* 🔴 Corrigido: usava "planoAtivo" (prop que não existe mais) */}
        {permiteEditarRefeicao && mostrarBotaoRefeicao && (
          <button
            className="btn-refeicao-personalizada"
            onClick={onAbrirModalRefeicao}
          >
            + Refeição
          </button>
        )}
      </div>

      <div className="painel-barra calorias">
        <div
          className="preenchido verde"
          style={{ width: `${progressoCalorias}%` }}
        ></div>
      </div>

      <p>
        {calorias} kcal de {metaCalorias} kcal
      </p>

      {possuiMacros && (
        <div className="resumo-macros-dia">
          <div className="macro-mini">
            <FontAwesomeIcon icon={faDrumstickBite} />
            <span>{macrosDia.proteinas} g proteína</span>
          </div>

          <div className="macro-mini">
            <FontAwesomeIcon icon={faBreadSlice} />
            <span>{macrosDia.carboidratos} g carboidrato</span>
          </div>

          <div className="macro-mini">
            <FontAwesomeIcon icon={faCheese} />
            <span>{macrosDia.gorduras} g gordura</span>
          </div>
        </div>
      )}

      {refeicoesDia.length > 0 && (
        <div className="grade-refeicoes-dia">
          {refeicoesDia.map((refeicao) => (
            <div
              key={refeicao.id}
              className="refeicao-linha"
              onClick={() => handleCliqueLinha(refeicao)}
            >
              <div className="refeicao-info">
                {obterIconeRefeicao(refeicao.refeicao_tipo_id)}

                <div className="refeicao-titulo-e-acoes">
                  <span className="refeicao-tipo">
                    {refeicao.nome_refeicao
                      ? refeicao.nome_refeicao
                      : obterNomeRefeicao(refeicao.refeicao_tipo_id)}
                  </span>

                  <div className="refeicao-acoes">
                    <button
                      type="button"
                      className="refeicao-icone-btn refeicao-icone-info"
                      onClick={(e) => handleCliqueInfo(e, refeicao)}
                      aria-label="Ver detalhes da refeição"
                    >
                      <FontAwesomeIcon icon={faCircleInfo} />
                    </button>

                    {permiteEditarRefeicao && (
                      <button
                        type="button"
                        className="refeicao-icone-btn refeicao-icone-excluir"
                        onClick={(e) => handleCliqueExcluir(e, refeicao)}
                        aria-label="Excluir refeição"
                      >
                        <FontAwesomeIcon icon={faTrashAlt} />
                      </button>
                    )}
                  </div>
                </div>
              </div>

              <span className="refeicao-kcal">
                {refeicao.calorias_total} kcal
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PainelCaloriasDia;